/**
 * Central Management > 통합관리 > 통합 스크립트
 * 내용보기 Store

 * @since 2018-06-29
 * @author devp018
 */

import {fnGetCodeVal} from '~/utils/admin-common'
import {pcDownloadFile} from '~/utils/files'
import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  // script: script,
  apiUrlPath: {
    script: '/api/cm/integrate-script/result'
  },
  downloadURL: '/api/cm/integrate-script/result/download',
  isActive: true,
  isColPopupShow: false,
  totalDataCount: 0,
  pageSize: 50,
  dataList: [],
  // searchData: [],
  scripResultData: [],
  scriptDownloadData: [],
  sid: '',
  name: '',
  makeTime: '',
  distription: '',
  scriptViewData: {
    script_uname: null, // 스크립트명
    script_result_dt: null, // 수행 시간
    script_exec_dt: null, // 실행 시간
    script_result_cntnt: null, // 결과
    device_id: null
  }
})
export const mutations = {
  setIsActive (state, payload) {
    state.isActive = Object.freeze(payload)
  },
  mutClearDownloadData (state) {
    state.scriptDownloadData = []
  },
  // 본문 리스트
  mutGetIntegrateScriptResultCnt (state, payload) {
    state.totalDataCount = Object.freeze(payload[0].cnt)
  },
  // 본문 리스트
  mutGetIntegrateScriptResultList (state, payload) {
    if (payload.length < 1) {
      state.scripResultData = []
    } else {
      const temp = []
      for (let i = 0; i < payload.length; i++) {
        temp.push({
          script_result_id: payload[i].script_result_id,
          script_result_dt: payload[i].script_result_dt,
          script_exec_dt: payload[i].script_exec_dt,
          script_uname: payload[i].script_uname,
          device_uname: payload[i].device_uname,
          script_result_type: fnGetCodeVal('script_result_type', payload[i].script_result_type),
          script_result_cntnt: payload[i].script_result_cntnt,
          script_desc: payload[i].script_desc,
          device_id: payload[i].device_id,
          script_id: payload[i].script_id
        })
      }
      state.scripResultData = Object.freeze(temp)
    }
  },
  // for excel dowload
  // mutGetIntegrateScriptResultDownload (state, payload) {
  //   if (payload.length < 1) {
  //     state.scriptDownloadData = []
  //   } else {
  //     const temp = []
  //     for (let i = 0; i < payload.length; i++) {
  //       temp.push({
  //         script_result_id: payload[i].script_result_id,
  //         script_result_dt: payload[i].script_result_dt,
  //         script_exec_dt: payload[i].script_exec_dt,
  //         script_uname: payload[i].script_uname,
  //         device_uname: payload[i].device_uname,
  //         script_result_type: fnGetCodeVal('script_result_type', payload[i].script_result_type),
  //         script_result_cntnt: payload[i].script_result_cntnt,
  //         script_desc: payload[i].script_desc,
  //         device_id: payload[i].device_id,
  //         script_id: payload[i].script_id
  //       })
  //     }
  //     state.scriptDownloadData = Object.freeze(temp)
  //   }
  // },
  fnColPopupShow (state, trueOrFalse) {
    state.isColPopupShow = Object.freeze(trueOrFalse)
  }
}

export const actions = {
  async getIntegrateScriptResultCnt ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.apiUrlPath.script}/count`, payload, {successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutGetIntegrateScriptResultCnt', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async getIntegrateScriptResultList ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.apiUrlPath.script}`, payload, {successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutGetIntegrateScriptResultList', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async getIntegrateScriptResult ({commit, state}, payload) {
    try {
      const {code, result} = await this.$axios.$get(`${state.apiUrlPath.script}/${payload}`, {successAlert: false})
      if (code.toUpperCase() !== 'OK') {
        return {code: false, result: {errors: result.msg}}
      }
      return {code: true, result: result}
    } catch (error) {
      return {code: false, result: {errors: error}}
    }
  },
  // async getIntegrateScriptResultDownload ({commit, state}) {
  //   try {
  //     const param = {
  //       page_cnt: 1000,
  //       page_pos: 0,
  //       scpt_s_result_dt: '',
  //       scpt_e_result_dt: '',
  //       script_result_type: 0,
  //       script_uname: '',
  //       device_id_list: '',
  //       device_uname: ''
  //     }
  //     const res = await this.$axios.$post(`${state.apiUrlPath.script}`, param, {successAlert: false})
  //     if (res.code.toLowerCase() === 'ok') {
  //       commit('mutGetIntegrateScriptResultDownload', res.result)
  //     }
  //     return res
  //   } catch (error) {
  //     const result = {}
  //     result.error = error
  //     commit('mutationErrorMessage', result)
  //     return ''
  //   }
  // }

  async getIntegrateScriptResultDownload ({commit, state}, payload) { // PC로 파일 다운로드
    const param = {
      responseType: 'blob',
      method: 'get',
      successAlert: false,
      returnErr: true
    }
    try {
      const result = await this.$axios.$file(state.downloadURL, payload, param)
      if (result.code !== undefined) {
        const blob = new Blob([result.data])
        const reader = new FileReader()
        reader.onload = () => {
          const msgObj = JSON.parse(reader.result)
          const msgTxt = msgObj.result.msg
          return {code: 'error', errors: msgTxt}
        }
        reader.readAsText(blob)
      } else {
        const nameData = result.fileName.replace('UTF-8\'\'', '')
        pcDownloadFile(result.data, nameData)
        return {code: 'ok'}
      }
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // Script 삭제
  async delScriptData ({commit, state}, payload) {
    const idList = []
    _.forEach(payload, item => {
      idList.push(item.script_result_id)
    })
    try {
      const data = await this.$axios.$delete(`${state.apiUrlPath.script}`, {data: {script_result_id_list: idList}})
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}

export const getters = {
}

export const strict = false
